import { IRubricsLinksState } from '../../../../types/rubricsLinks';

interface IRubric {
  key: keyof IRubricsLinksState;
  title: string;
}

export const RUBRICS: IRubric[] = [
  { key: 'rent', title: 'Аренда' },
  { key: 'sale', title: 'Продажа' },
  { key: 'residentialComplexes', title: 'Новостройки' },
  { key: 'countryside', title: 'Дома и участки' },
  { key: 'villages', title: 'Коттеджные посёлки' },
  { key: 'rentDaily', title: 'Посуточно' },
  { key: 'commercial', title: 'Коммерческая' },
  { key: 'mortgage', title: 'Ипотека' },
  { key: 'magazine', title: 'Журнал' },
  { key: 'askAgent', title: 'Вопросы риэлтору' },
];
